























































































import {Component, Vue} from "vue-property-decorator";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";
import {MainPageConfig} from "@/interfaces/main-page.interface";
import {bus} from "@/plugins/bus";
import {EventEmitter} from "@/interfaces/store-interfaces/event-emitter.interface";
import HeroRhizome from "@/components/HeroRhizome.vue";
import TextBox from "@/components/TextBox.vue";
import LogoBox from "@/components/LogoBox.vue";
import PathBox from "@/components/PathBox.vue";
import BackgroundText from "@/components/BackgroundText.vue";
import WordCloud from "@/components/WordCloud.vue";
import Button from "@/components/Button.vue";
import ContentPage from "@/components/ContentPage.vue";
import VideoSync from "@/components/VideoSync.vue";
import Quote from "@/components/Quote.vue";
import VideoBox from "@/components/VideoBox.vue";
import ImageGrid from "@/components/ImageGrid.vue";
import VideoContent from "@/components/VideoContent.vue";
import {ThemePathPageConfig} from "@/interfaces/theme-path-page.interface";

@Component({
  components: {
    TextBox,
    PathBox,
    ContentPage,
    WordCloud,
    BackgroundText,
    LogoBox,
    HeroRhizome,
    Button,
    VideoSync,
    Quote,
    VideoBox,
    ImageGrid,
    VideoContent,
  }
})

export default class PathOverview extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  isLoading = true;

  single: MainPageConfig.ITheme[] = [];
  double: MainPageConfig.ITheme[] = [];

  filmViewModes = ThemePathPageConfig.FilmViewModes;
  blockTypes = MainPageConfig.PageBlockTypes;
  pageContent: MainPageConfig.IMainPageConfig;

  async created() {
    this.pageContent = await this.$store.dispatch("contentPage/getPageContent", {page: RouterStore.ROUTE_NAME.PATH_OVERVIEW_PAGE});

    let countOneInARow = 0;

    if (this.pageContent.content.length < 4) {
      countOneInARow = this.pageContent.content.length
    } else {
      countOneInARow = this.pageContent.content.length - 2 * Math.floor(this.pageContent.content.length / 3)
    }

    let block: any = this.pageContent.content.find(block => block.type === this.blockTypes.THEMES);
    if (block) {
      this.single = block.themes.themes.splice(0, countOneInARow);
      this.double = block.themes.themes;
    }

    this.isLoading = false;

    setTimeout( () => {
      bus.$emit(EventEmitter.Events.DATA_LOADED);
    })
  }
}
